__turbopack_context__.v({
  "boldText": "NEa7Ia_boldText",
  "container": "NEa7Ia_container",
  "description": "NEa7Ia_description",
  "header": "NEa7Ia_header",
  "table": "NEa7Ia_table",
  "tableColumn": "NEa7Ia_tableColumn",
  "tableHeader": "NEa7Ia_tableHeader",
  "tableRow": "NEa7Ia_tableRow",
  "tableRowItem": "NEa7Ia_tableRowItem",
  "title": "NEa7Ia_title",
});
